<template>
    <div>
        <mume-table ref="ctable" :singleSelect="true" :searchForm="filterForm" :callback="table.callback" :api="table.api"
            :column="table.column" method="get" :batchAction="batchAction" @single-change="selectGroup">
        </mume-table>
        <group-layper :innerDialog="true" ref="groupLayper" @onSubmitCallback="$refs.ctable.getData()"></group-layper>
    </div>
</template>

<script>
import mumeTable from '../../plugin/mume-table.vue';
import groupLayper from './add-group.vue'
export default {
    components: { mumeTable, groupLayper },
    data() {
        return {
            batchAction: [{ text: "新建分组", action: this.gotoAdd, type: "primary" }],
            table: {
                api: "api/seller/getGroupList",
                callback: (res, data) => {
                    if (res.data.obj) {
                    }
                },
                column: [
                    { label: "分组名称", name: "title" },
                ],
            }
        }
    },
    methods: {
        gotoAdd() {
            this.$refs.groupLayper.open()
        },
        selectGroup(group){
            this.$emit("selectGroup",group)
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/customer/lapyer/group-list.vue